module.exports = __webpack_public_path__ + "static/img/tooltip-custom-thrust-arcs.0e37d4d.png";